import { render, staticRenderFns } from "./TaskSettings.vue?vue&type=template&id=6612d4b6&scoped=true"
import script from "./TaskSettings.vue?vue&type=script&lang=js"
export * from "./TaskSettings.vue?vue&type=script&lang=js"
import style0 from "./TaskSettings.vue?vue&type=style&index=0&id=6612d4b6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6612d4b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6612d4b6')) {
      api.createRecord('6612d4b6', component.options)
    } else {
      api.reload('6612d4b6', component.options)
    }
    module.hot.accept("./TaskSettings.vue?vue&type=template&id=6612d4b6&scoped=true", function () {
      api.rerender('6612d4b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/operationsManagement/Component/TaskSettings.vue"
export default component.exports